const Component = {
  "图片 url 不存在": "图片 url 不存在",
  "暂不支持下载此类型图片": "暂不支持下载此类型图片",
}

export default Component;
